module.exports = __webpack_public_path__ + "static/media/circle3.1dcce63c.svg";